/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../base/base.service.ts" />
/// <reference path="../login/login.model.ts" />

module Eseebase {
    export class CompanyService {
        constructor(private $http: ng.IHttpService, private baseService: BaseService, private $q: ng.IQService, private cookiesService: CookiesService) { }

        public list() {
            return this.baseService.get('company/list').then((data) => data.data);
        }

        public save(company: CompanyViewModel) {
            return this.baseService.put('company', company).then((data) => data.data);
        }

        public delete(companyNumber: string) {
            return this.baseService.post('company/' + companyNumber + '/deactivate', {}).then(files => { return files.data });
        }

        public getCurrentCompanyNumber() {
            return this.cookiesService.readCookie('company');
        }

        public getCompany(id: string) {
            return this.baseService.get('company/' + id).then((data) => data.data);
        }

        public getUiStyles() {
            return this.baseService.get('company/uistyles').then((data) => data.data);
        }

        public rerunModels(associationNumber, departmentNumber) {
            if (associationNumber == null) {
                return this.baseService.post('task/schedule/{companyNumber}/rerun', {});
            }
            else if (departmentNumber == null){
                return this.baseService.post('task/schedule/{companyNumber}/' + associationNumber + '/rerun', {});
            }
            else {
                return this.baseService.post('task/schedule/{companyNumber}/' + associationNumber + '/rerun?departmentNumber=' + departmentNumber, {});
            }
        }

        public modelsToSvf(associationNumber, departmentNumber) {
            return this.baseService.post('forge/{companyNumber}/to-svf-multiple?associationNumber=' + associationNumber + '&departmentNumber=' + departmentNumber, {});
        }

    }

    CompanyService.$inject = ['$http', 'BaseService', '$q', 'CookiesService'];
    angular
        .module('eseebase')
        .service('CompanyService', CompanyService);
}